/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { AuthStrictHttpResponse } from '../../auth-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerifyOtpRequestModel } from '../../models/verify-otp-request-model';

export interface LocalAccountVerifyOtpAsyncPost$Params {
      body?: VerifyOtpRequestModel
}

export function localAccountVerifyOtpAsyncPost(http: HttpClient, rootUrl: string, params?: LocalAccountVerifyOtpAsyncPost$Params, context?: HttpContext): Observable<AuthStrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, localAccountVerifyOtpAsyncPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as AuthStrictHttpResponse<boolean>;
    })
  );
}

localAccountVerifyOtpAsyncPost.PATH = '/LocalAccount/VerifyOTPAsync';
